import styled, { css } from 'styled-components';
import { COLORS, FONTS } from '@app/src/ui';
import { Icon } from '@app/src/components/Icon';

export const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 30px;
`;

const styleTextSize = css`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 80%;
`;

export const MainTitle = styled.div`
  flex: 1;
  ${styleTextSize}
`;

export const Text = styled.div`
  ${styleTextSize}
`;

export const State = styled.div`
  text-align: right;
`;

export const Content = styled.div`
  display: block;
  width: 100%;
  text-align: center;
`;

export const Cell = styled.div`
  margin-bottom: 15px;
`;

export const Title = styled.div`
  font-size: 12px;
  line-height: 16px;
  font-weight: bold;
`;

export const ItemTable = styled.div`
  width: 25%;
  overflow: hidden;
  overflow-wrap: break-word;
  text-align: center;
  &:last-child {
    width: 5%;
  }
`;

export const ResponsiveName = styled.div`
  overflow: hidden;
  height: 20px;
`;

export const UserCounter = styled.div`
  order: 2;
  @media(max-width: 768px) {
    margin-bottom: 28px;
    order: initial;
  }`
;

export const WrapperPaginator = styled.div`
  font-family: ${FONTS.ROBOTO_REGULAR};
  color: ${COLORS.BLACK};
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  margin: 30px 0;
  font-size: 14px;
  line-height: 16px;
  @media(max-width: 768px) {
    flex-direction: column;
  }
`;

export const Space = styled.div`
  width: 5%;
`;

export const EditIcon = styled(Icon)`
  cursor: pointer;
`;

export const EditIconResponsive = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 112px;
  cursor: pointer;
`;
